module.exports = __webpack_public_path__ + "static/chi-siamo-4b3e658714eb48574ab73e9ea2e3aafc.jpg";